import { reportApi } from '../http/httpClient'

export interface ReportCoupons {
  user: string
  cpf: string
  code: number
  prizedraw: string
  createdAt: string
}

export interface ReportCouponsResponse {
  coupons: ReportCoupons[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
  }
}

export interface ReportCouponsParams {
  search?: string
  sellerIds?: string
  startDate?: string
  endDate?: string
  maxValue?: string
  minValue?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function reportCoupons(params?: ReportCouponsParams | undefined) {
  const { data } = await reportApi.get<ReportCouponsResponse>(
    '/report/coupons',
    {
      params,
    },
  )

  return data
}
